import React from "react";
import { makeStyles, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    width: "100%",
    padding: "70px 0px",
    margin: "70px 0",
    textAlign: "center",
  },
  bannerHeading: {
    fontSize: "108px",
    color: theme.palette.secondary.light,
    fontWeight: 600,
    letterSpacing: 0.1,
    margin: "0 20px",
    lineHeight: "120px",
    [theme.breakpoints.down("md")]: {
      fontSize: "64px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "56px",
      lineHeight: "60px",
      marginTop: "30px",
    },
  },
  exploreBtn: {
    color: theme.palette.primary.main,
    backgroundColor: "black",
    borderRadius: 2,
    boxShadow: "none",
    padding: "10px 75px",
    margin: "20px 0",
    "&:hover": {
      color: "white",
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

function BookPurchaseBanner() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <h2 className={classes.bannerHeading}>Book Purchase</h2>
      <p style={{ maxWidth: "90%", margin: "40px auto" }}>
        By using this website to publish and distribute your literary work(s),
        you hereby agree not to hold decade 2 publishing, its parent company,
        CONTINENT 5 MEDIA GROUP, or its employs, associates, or affiliates
        liable or accountable for loss or harm from any action sustained by you,
        or caused by you, or brought against you, your name, stead, likeness,
        alias, moniker, surname, or any other name under which you write, use,
        or perform under, individually and collectively
      </p>
      <Button variant="contained" className={classes.exploreBtn}>
        EXPLORE
      </Button>
    </div>
  );
}

export default BookPurchaseBanner;
